/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/promise-function-async */
import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { useAuthContext, OverviewWrapper, LoadingSpinner } from '@catalyze/ui';
import { useGetLeadsQuery } from 'api/leads/getLeads';
import { getLeadsWorth, useGetLeadsWorthQuery } from 'api/leads/getLeadsWorth';
import { Status } from 'api/types/lead';
import { OverviewSection } from 'components/OverviewSection';
import { LeadGroups } from 'constants/leadGroups';
import { NonPaidEmptyState } from 'features/RealEstate/components/NonPaidEmptyState';

import { LoadingContainer, StyledH1 } from './styled';

export const Overview: FC = () => {
    const { user } = useAuthContext();
    const [isSubscriptionLoading, setIsSubcriptionLoading] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(true);

    const {
        data: recommended,
        isLoading: isRecommendedLoading,
        refetch: recommendedRefetch,
    } = useGetLeadsQuery({
        status: Status.RECOMMENDED,
        pageSize: 8,
    });

    const { data: recommendedNetWorth, refetch: recommendedNetWorthFetech } =
        useGetLeadsWorthQuery({
            status: Status.RECOMMENDED,
            search: '',
            activeFilters: {},
        });

    const {
        data: contacted,
        isLoading: isContactedLoading,
        refetch: contactedRefetch,
    } = useGetLeadsQuery({
        status: Status.CONTACTED,
        pageSize: 8,
    });

    const { data: contactedNetWorth, refetch: contactedNetWorthRefetch } =
        useGetLeadsWorthQuery({
            status: Status.CONTACTED,
            search: '',
            activeFilters: {},
        });

    const {
        data: active,
        isLoading: isActiveLoading,
        refetch: activeRefetch,
    } = useGetLeadsQuery({
        status: Status.ACTIVE,
        pageSize: 8,
    });

    const { data: activeNetWorth, refetch: activeNetWorthRefetch } =
        useGetLeadsWorthQuery({
            status: Status.ACTIVE,
            search: '',
            activeFilters: {},
        });

    const isUserNew = user?.subscription === null;

    useEffect(() => {
        let count = 0;
        const checkLeads = async () => {
            if (count >= 5000) {
                setIsPageLoading(false);
                setIsSubcriptionLoading(false);
                return;
            }

            const data = await getLeadsWorth({
                status: Status.ALL,
                search: '',
                filterQueryParams: {},
            });

            if (data.allLeads === 0) {
                setIsSubcriptionLoading(true);
                setIsPageLoading(true);
                count += 1;
                setTimeout(() => checkLeads(), 5000);
            } else {
                if (count > 0) {
                    await Promise.all([
                        recommendedRefetch(),
                        contactedRefetch(),
                        activeRefetch(),
                        recommendedNetWorthFetech(),
                        contactedNetWorthRefetch(),
                        activeNetWorthRefetch(),
                    ]);
                }
                setIsPageLoading(false);
                setIsSubcriptionLoading(false);
            }
        };
        if (!isUserNew) {
            checkLeads();
        }
    }, []);

    if (!isUserNew && isSubscriptionLoading) {
        return (
            <LoadingContainer>
                <LoadingSpinner />
                <p>Congratulations!</p>
                <p>
                    Your data is being prepared, this process can take a few
                    minutes, you can either wait on this screen or check back
                    later!
                </p>
            </LoadingContainer>
        );
    }

    if (!isUserNew && isPageLoading) {
        return (
            <LoadingContainer>
                <LoadingSpinner />
            </LoadingContainer>
        );
    }

    return (
        <OverviewWrapper>
            {isUserNew ? (
                <NonPaidEmptyState />
            ) : (
                <>
                    <StyledH1>Overview</StyledH1>
                    <OverviewSection
                        type={LeadGroups.RECOMMENDED}
                        status={Status.RECOMMENDED}
                        data={recommended ?? []}
                        isLoading={isRecommendedLoading}
                        count={recommendedNetWorth?.count}
                    />
                    <OverviewSection
                        type={LeadGroups.CONTACTED}
                        data={contacted ?? []}
                        isLoading={isContactedLoading}
                        status={Status.CONTACTED}
                        count={contactedNetWorth?.count}
                    />
                    <OverviewSection
                        type={LeadGroups.ACTIVE_CONVERSATION}
                        data={active ?? []}
                        isLoading={isActiveLoading}
                        status={Status.ACTIVE}
                        count={activeNetWorth?.count}
                    />
                </>
            )}
        </OverviewWrapper>
    );
};
